type Listener = () => void;

type AppMenuState = {
  hiddenRouteKeys: Set<string>;
};

const defaultState = (): AppMenuState => ({
  hiddenRouteKeys: new Set()
});

let state = defaultState();
let listeners: Listener[] = [];

const notify = () => listeners.forEach(l => l());

export const appMenuController = {
  /** Read-only state */
  getState(): AppMenuState {
    return state;
  },

  /** Hide specific menu items */
  hide(keys: string[]) {
    keys.forEach(k => state.hiddenRouteKeys.add(k));
    notify();
  },

  /** Show specific menu items */
  show(keys: string[]) {
    keys.forEach(k => state.hiddenRouteKeys.delete(k));
    notify();
  },

  /** Reset menu back to default */
  reset() {
    state = defaultState();
    notify();
  },

  /** Subscription for AppMenu */
  subscribe(listener: Listener) {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  }
};
